/**
 配置信息--配电柜管理
 */
import React, { Component } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import { Modal, Button, message } from "antd";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import fetchHandler from "@/fetch/fetchHandler";
import PowerBoxDetail from "./PowerBoxDetail";
import RefreshGrid from "../../../utils/refreshGrid";
import PropTypes from "prop-types";
import StubStatusUpdate from "./stubStatusUpdate";
import FormCore from "../../../components/display/form/formCore";
import { getPowerBoxList, prefixFile, getCityList } from "../../../fetch/fetchApi";
import { useAuth } from "@/utils/utils";
@connect((state) => state)
class PowerBoxList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.isFirst = true;
    this.state = {
      detailData: {},
      internationalization: this.props.intl.messages.powerBoxList,
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };
  componentWillMount() {
    // 初始定义表格数据
    this.initGrid();
    this.getCityList();
    // 清除数据
    localStorage.clear();
  }
  generateTableButtons() {
    return (
      <div className="table-btn-group">
        <Button type="primary" style={{ marginRight: "5px" }} onClick={() => this.selectCurrent()}>
          批量绑定推送人
        </Button>
      </div>
    );
  }

  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList, { userId: sessionStorage.getItem("userId") }).then((res) => {
      if (!res.data) {
        return;
      }
      const fetchPickerOptions = res.data;
      let formatOptionsStr = JSON.stringify(fetchPickerOptions);
      formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
      const cityAryy = JSON.parse(formatOptionsStr);
      cityAryy.map((item) => {
        item.key = item.value;
        item.children.map((item2) => {
          item2.key = item2.value;
          delete item2.children; // 删除子区域数据
          return true;
        });
        return true;
      });
      // 初始化城市数据
      // this.quanguoCityArry = [
      //   {
      //     title: "全国",
      //     value: "000000",
      //     key: "000000",
      //     children: JSON.parse(JSON.stringify(cityAryy)),
      //   },
      // ];

      this.quanguoCityArry = JSON.parse(JSON.stringify(cityAryy));
      // 只能选择城市的方式
      this.quanguoCityNotP = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotP.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = false;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择省份的数组
      this.quanguoCityNotCity = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotCity.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = false;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择全国的数组
      this.quanguoCityNotChild = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotChild.map((item) => {
        item.disabled = false;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 设置数据
      console.log(1111);
      console.log(this.quanguoCityArry);
      console.log(1111);
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initGrid(),
          });
        },
      );
    });
  };

  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initGrid(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = "";
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (
        value[0].charAt(5) === "0" &&
        value[0].charAt(4) === "0" &&
        value[0].charAt(3) === "0" &&
        value[0].charAt(2) === "0"
      ) {
        quanguoCityArryCVal = this.quanguoCityArry;
      } else {
        quanguoCityArryCVal = this.quanguoCityArry;
      }
      // 设置数据
      // console.info('囫')
      // console.info(this.state.quanguoCityArry)
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.initGrid(),
          });
        },
      );
    }
  };

  selectCurrent = () => {
    var id = [];
    if (this.state.selectedRows) {
      this.state.selectedRows.forEach((key) => {
        id.push(key.key);
      });
    }
    if (id.length > 0) {
      this.setState({
        seeStubStatusVisible: true,
        stubIds: id.join(","),
        isBatch: 1,
        stubId: null,
      });
    } else {
      message.error("请至少选择一个配电柜");
    }
  };

  initGrid() {
    this.queryStubId = "";
    this.queryStubName = "";
    this.queryMeterModuleId = "";

    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.queryStubId = window.LayoutTab.tabParam.stubId ? window.LayoutTab.tabParam.stubId : "";
      this.queryStubName = window.LayoutTab.tabParam.stubGroupName
        ? window.LayoutTab.tabParam.stubGroupName
        : "";
      this.queryStubGroupId = window.LayoutTab.tabParam.stubGroupId
        ? window.LayoutTab.tabParam.stubGroupId
        : "";
      this.queryMeterModuleId = window.LayoutTab.tabParam.meterModuleId
        ? window.LayoutTab.tabParam.meterModuleId
        : "";
    }
    console.log(this.queryStubGroupId);
    this.formConfig = {
      childItems: [
        {
          type: "input",
          inputType: "text",
          param: {
            name: "meterModuleId", // 提交的参数
            type: "string",
          },
          labelName: "抄表模块编号", // '抄表模块编号',
          placeholder: "请输入抄表模块编号", // '请输入抄表模块编号'
          defaultValue: this.queryMeterModuleId,
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },
        {
          type: "input",
          inputType: "text",
          placeholder: this.state.internationalization.placeholder2,
          param: {
            name: "stubGroupName",
            type: "string",
          },
          labelName: this.state.internationalization.title2, // '电站名称:',
          defaultValue: this.queryStubName,
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择状态',
          labelName: "状态", // '状态',
          param: {
            name: "status",
            type: "string",
          },
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "离线",
              value: "05",
            },
            {
              text: "在线",
              value: "00",
            },
          ],
          required: false,
          // defaultValue: this.operationMode ? this.operationMode : ''
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("010401")
              ? {
                  btnType: "submit",
                  text: this.state.internationalization.btn1,
                  // icon: 'search'
                }
              : "",
            useAuth("010402")
              ? {
                  btnType: "button",
                  text: "导出", // '导出',
                  handler: (e, param) => {
                    const newParam = param;
                    newParam.token = window.sessionStorage.getItem("token");
                    newParam.companyId = window.sessionStorage.getItem("companyId");
                    newParam.flag = 1;
                    let paramString = "";
                    if (newParam.cityGroup == null || newParam.cityGroup.length == 0) {
                      newParam.cityId = "";
                    } else {
                      newParam.cityId = newParam.cityGroup.join(",");
                    }
                    Object.keys(newParam).forEach((key) => {
                      const paraminfo = newParam[key] ? newParam[key] : "";
                      paramString += `${key}=${paraminfo}&`;
                    });
                    this.exportOrderStuGroup(paramString);
                  },
                }
              : "",
          ],
        },
      ], // 设置表单元素
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        stubGroupName: this.queryStubName,
        stubGroupId: this.queryStubGroupId,
        meterModuleId: this.queryMeterModuleId,
      },
      autoLoadGrid: 1, // 设置为false不触发加载grid
      context: this,

      tableKey: "powerBoxTable",
    };
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: "配电柜编号", // '配电柜编号',
            key: "key",
            align: "left",
          },
          {
            name: "抄表模块编号",
            message: (
              <div className="mcjs" style={{ width: "350px", maxWidth: 500 }}>
                <p style={{ textAlign: "center" }}>
                  <b>抄表模块编码规则</b>
                </p>
                <p>
                  <b>抄表模块采用9位纯数字编码：</b>
                </p>
                <p style={{ fontSize: 14 }}>
                  <b>1.开头+8位数字：</b>用于ERP上线的，现场没安装抄表模块的虚拟编号
                </p>
                <p style={{ fontSize: 14 }}>
                  <b>2.开头+8位数字：</b>2G智能抄表模块
                </p>
                <p style={{ fontSize: 14 }}>
                  <b>3.开头+8位数字：</b>用于ALM上线的，现场没安装抄表模块的虚拟编号
                </p>
                <p style={{ fontSize: 14 }}>
                  <b>4.开头+8位数字：</b>4G cat1智能抄表模块
                </p>
                <p style={{ fontSize: 14 }}>
                  <b>5.开头+8位桩编号：</b>
                  485方案编号（需要桩端软件按既定的编码上报数据，要与桩端沟通）
                </p>
              </div>
            ),
            key: "meterModuleId",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.state.internationalization.title2,
            key: "stubGroupName",
            align: "left",
            colType: "textCol",
            render: (value) => {
              if (value.length > 10) {
                return <span title={value}>{value || "--"}</span>;
              } else if (value) {
                return value;
              } else {
                return "--";
              }
            },
          },
          {
            name: this.state.internationalization.wz1, // '固件信息',
            key: "frameWork",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              if (value !== "--" && value && row.updateType) {
                return `${row.updateType.replace(/(^\s*)|(\s*$)/g, "")}-${value.replace(
                  /(^\s*)|(\s*$)/g,
                  "",
                )}`;
              } else {
                return "--";
              }
            },
          },
          {
            name: this.state.internationalization.wz2, // '电表编号',
            key: "meterId",
            align: "left",
          },
          {
            name: this.state.internationalization.title8,
            key: "ratedPower",
            colType: "numCol",
            align: "center",
            width: 200,
          },
          {
            name: this.state.internationalization.title13,
            key: "status",
            colType: "textCol",
            align: "center",
            width: 200,
            render: (value, row) => {
              if (!value || value == null || (value != "00" && value != "05")) {
                return "--";
              } else if (value == "05") {
                return "离线";
              } else {
                return "在线";
              }
            },
          },
          {
            name: this.state.internationalization.wz3,
            key: "cityName",
            colType: "textCol",
            align: "center",
            width: 200,
          },
          {
            name: this.state.internationalization.action,
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            fix: "right",
            width: 80,
            align: "center",
            actionMap: [
              useAuth("010403")
                ? {
                    type: "href",
                    actionName: this.state.internationalization.title9, // 基础信息,
                    handler: (res) => {
                      this.powerboxInfoData = res;
                      this.modalVisibleAction("seeDetailVisible", true);
                      this.setState({
                        seeDetailVisible: true,
                      });
                    },
                  }
                : "",
              useAuth("010404")
                ? {
                    type: "href",
                    actionName: this.state.internationalization.title10, //设备列表
                    handler: (record) => {
                      // localStorage.meterModuleId = record.meterModuleId;
                      this.openTab(
                        {
                          // keyId: `stub`,
                          meterModuleId: record.meterModuleId,
                        },
                        {
                          key: "0102",
                          titleText: this.state.internationalization.title11,
                        },
                      );
                    },
                  }
                : "",
              useAuth("010405")
                ? {
                    type: "href",
                    actionName: this.state.internationalization.title14, //绑定推送人
                    handler: (record) => {
                      this.setState({
                        seeStubStatusVisible: true,
                        stubId: record,
                        isBatch: null,
                      });
                    },
                  }
                : "",
            ],
          },
        ],
        tableParam: {
          pageCount: 10,
        },
        tableInfo: {
          hasRow: !0, // 是否显示checkbox
          footer: useAuth("010406") ? this.generateTableButtons() : null,
          rowSelection: {
            selectedRowKeys: this.state ? this.state.selectedRowKeys : [],
            onChange: (selectedRowKeys, selectedRows) => {
              this.setState(
                {
                  selectedRowKeys,
                  selectedRows,
                },
                () => {
                  this.setState({
                    // ...this.init(),
                  });
                },
              );
            },
          },
        },
        tableChange: () => {
          // grid翻页页，排序， 筛选过滤时触发
          console.debug("change");
        },
        autoRefresh: true, // 设置为true 直接加载grid数据
        dataApi: getPowerBoxList,
        tableKey: "powerBoxTable",
      },
    });
    this.isFirst = false;
  }

  exportOrderStuGroup = (paramString) => {
    const excelUrl = `${prefixFile}/powerBoxList.do`;
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  fetchApi = (param) => {
    if (!this.isFirst) {
      param.stubGroupId = "";
    }
    const newParam = param;
    if (param.cityGroup == null || param.cityGroup.length == 0) {
      newParam.cityIds = "";
    } else {
      newParam.cityIds = param.cityGroup.join(",");
    }
    delete newParam.cityGroup;
    // 加载表格
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "powerBoxTable", newParam);
    }
  };

  render() {
    return (
      <div>
        <div className="page-toolbar">
          {/* eslint-disable-next-line react/jsx-no-bind */}
          <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi.bind(this)} />
        </div>
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>
        <Modal
          title={this.state.internationalization.title12}
          visible={this.state.seeDetailVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeDetailVisible", false);
          }}>
          <PowerBoxDetail powerboxInfoData={this.powerboxInfoData} />
        </Modal>
        <Modal
          title={this.state.internationalization.title14}
          visible={this.state.seeStubStatusVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeStubStatusVisible", false);
          }}>
          <StubStatusUpdate
            stubIds={this.state.stubIds}
            stubId={this.state.stubId}
            isBatch={this.state.isBatch}
            onCancel={() => {
              this.setState({ seeStubStatusVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "powerBoxTable");
            }}
          />
        </Modal>
      </div>
    );
  }
}

export default injectIntl(PowerBoxList);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/powerBox/powerBoxList.js